import {api} from "@/lib/api";
import dayjs from "dayjs";
import {message} from "ant-design-vue";
import {Brand} from "@/model/brand";
import {Employee} from "@/model/employee";

export interface IBranch {
    branch_id: string;
    brand_id: string;
    name: string;
    province: string;
    city: string;
    district: string;
    address: string;
    coordinate: number[];
    tel: string;
    wx_account_qr_code: string | null;
    subscribe_wx_open_id: string | null;
    trash_at: string | null;
}

export class Branch {
    constructor(readonly brand: Brand, readonly meta: IBranch) {
    }

    async update(br: IBranch): Promise<void> {
        if (br.branch_id !== this.meta.branch_id || br.brand_id !== this.meta.brand_id) return
        return api({
            url: `user/${this.brand.meta.agent_id}/brand/${br.brand_id}/branch/${br.branch_id}`,
            method: 'PUT',
            data: br
        }).then(() => {
            Object.assign(this.meta, br)
        })
    }

    async remove(): Promise<void> {
        const done = message.loading('移除中', 0)
        return api({
            url: `user/${this.brand.meta.agent_id}/brand/${this.brand.meta.brand_id}/branch/${this.meta.branch_id}`,
            method: 'DELETE',
        }).then(() => {
            this.meta.trash_at = dayjs().format('YYYY-MM-DD HH:mm:ss');
        }).finally(done)
    }

    async restore(): Promise<void> {
        const done = message.loading('恢复中', 0)
        return api({
            url: `user/${this.brand.meta.agent_id}/brand/${this.brand.meta.brand_id}/branch/${this.meta.branch_id}`,
            method: 'PATCH'
        }).then(() => {
            this.meta.trash_at = null
        }).finally(done)
    }

    async employees(): Promise<Employee[]> {
        return await this.brand.userAgent.loadEmployees([this.meta.branch_id]).then(es => es.map(e => new Employee(this, e))) ?? []
    }

    async regAppletQR(): Promise<Blob> {
        return api({
            url: `user/${this.brand.meta.agent_id}/brand/${this.brand.meta.brand_id}/branch/${this.meta.branch_id}/employee/reg/qr`,
            responseType: 'blob'
        })
    }
}